import { ServicesContainer } from '@/services';
import { InternalCampaignEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, Marketing } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeInternalCampaignEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.PageLoaded;
  marketing: Marketing = {};

  constructor(event: InternalCampaignEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.marketing = {
        internalCampaign: event.campaign,
        internalCampaignClicks: { 'value': 1 },
    }
  }
}